<template>
  <div class="media-item">
    <div style="display: flex" class="newRow">
      <h4 style="margin-right: 25px; line-height: 32px">Media Items</h4>
      <div class="sub" style="order: 2; line-height: 32px; cursor: pointer">
        <base-button
          type="primary"
          :disabled="disabled"
          @click="showMediaSelectDialog"
          link
          class="base-icon-button"
        >
          <span class="icon-button add" style="margin-right: 10px">
            <el-icon color="#fff" style="vertical-align: middle">
              <plus />
            </el-icon>
          </span>
          New Items</base-button
        >
      </div>
    </div>

    <div
      class="newRow newCard"
      v-for="(item, index) in OrderMediaItems"
      :key="item"
    >
      <div class="row">
        <div class="col-md-12 description-line">
          <div
            class="row description col-sm-12"
            style="display: flex; justify-content: space-between"
          >
            <div class="col-sm-6 newText">
              #{{ index + 1 }} {{ item.mediaName }}
            </div>
            <div class="col-sm-6 text-right">
              <!-- Action <i class="el-icon-arrow-down el-icon--right"></i> -->
              <el-dropdown :disabled="disabled" trigger="click">
                <span
                  >Action
                  <el-icon class="el-icon--right">
                    <caret-bottom />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="CopyMedia(index)"
                      >Copy</el-dropdown-item
                    >
                    <el-dropdown-item @click="EditMedia(index)"
                      >Edit</el-dropdown-item
                    >
                    <el-dropdown-item @click="DeleteMedia(index)"
                      >Delete</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 description-line">
          <div class="row description col-sm-12">
            <div class="col-sm-3">
              <span>Material: </span
              ><label>{{ getMediaTechinologyValue(index) }}</label>
            </div>
            <div class="col-sm-3">
              <span>Location: </span
              ><label>{{ getLocationDescriptionValue(index) }}</label>
            </div>
            <div class="col-sm-2">Internal Code: {{ item.internalCode }}</div>
            <div class="col-sm-2">
              <span>Subgroup Code: </span><label>{{ item.subgroupCode }}</label>
            </div>
            <div class="col-sm-2">
              <span>Site Code: </span><label>{{ item.siteCode }}</label>
            </div>

            <div class="col-sm-12">
              <div style="display: flex; align-items: center">
                <div>
                  <el-button
                    link
                    class="base-icon-button append"
                    :disabled="disabled"
                    @click="showMediaAppendDialog(index)"
                    style="padding: 0.5rem 0.7rem 0.5rem 0"
                    v-if="false"
                  >
                    <div
                      class="icon-button add"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <el-icon color="#fff" style="vertical-align: middle">
                        <plus />
                      </el-icon>
                    </div>
                  </el-button>
                </div>
                <div style="padding-right: 7px">Append:</div>
                <div style="flex-grow: 1">
                  <append :text="item.append" v-if="false" />
                  <base-input>
                    <el-input
                      type="textarea"
                      :rows="1"
                      v-model="item.append"
                      :disabled="disabled"
                    ></el-input>
                  </base-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table border :data="[item]">
            <el-table-column prop="" label="Bonus" width="70">
              <template #default="scope">
                <div></div>
                <div>
                  <base-checkbox
                    v-model="scope.row.isBonus"
                    :disabled="disabled"
                  ></base-checkbox>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="priceOption"
              label="Price Option"
              min-width="130"
            >
              <template #default="{ row }">
                {{ row.media_plan?.label }}
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="rateOption"
              label="Rate Option"
              min-width="130"
            /> -->
            <el-table-column prop="unitQty" label="Unit Qty" min-width="70" />
            <el-table-column
              prop="grossRate"
              min-width="130"
              :formatter="formatterCellMoney"
            >
              <template #header>
                Gross Rate
                {{
                  mediaJs.unitGrossRate_str(item?.unitRateOptionObject?.type)
                }}
              </template>
              <template #default="scope">
                <div
                  v-if="!disabled && useContract.ContractType == 'media'"
                  class="input-currency-noarea"
                >
                  <base-input
                    v-model="scope.row.grossRate"
                    @change="changeGrossItemSum(scope.row)"
                    @blur="inputBlur(index, 'grossRate')"
                    :class="{
                      'input-money': true,
                      'has-error': validation.isError(
                        scope.row.validate,
                        'grossRate'
                      ),
                    }"
                  >
                    <template #addonLeft>
                      <div class="currency">$</div>
                    </template>
                  </base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="quantity"
              label="QTY / Sec/Hr"
              min-width="70"
            >
              <template #default="scope">
                <div v-if="!disabled">
                  <base-input
                    v-model="scope.row.quantity"
                    @change="changeGrossItemSum(scope.row)"
                    @blur="inputBlur(index, 'quantity')"
                    :class="{
                      'has-error': validation.isError(
                        scope.row.validate,
                        'quantity'
                      ),
                    }"
                  ></base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="isToBeConfirmed" label="TBC" min-width="50">
              <template #header>
                <div>
                  <span>TBC&nbsp;&nbsp;&nbsp;</span>
                  <span>
                    <el-popover
                      placement="top-start"
                      :width="280"
                      trigger="hover"
                      content="Campaign period To Be Confirmed"
                    >
                      <template #reference>
                        <el-icon :size="18">
                          <Warning />
                        </el-icon>
                      </template>
                    </el-popover>
                  </span>
                </div>
              </template>

              <template #default="scope">
                <div>
                  <base-checkbox
                    v-model="scope.row.isToBeConfirmed"
                    :disabled="disabled"
                  ></base-checkbox>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="dates"
              label="Campaign Period"
              min-width="150"
              :formatter="CampaignPeriodFormatter"
            >
              <template #default="scope">
                <div v-if="!disabled" class="form-group">
                  <base-input :class="{ 'is-error': scope.row.dates == null }">
                    <el-date-picker
                      v-model="scope.row.dates"
                      type="daterange"
                      range-separator="-"
                      :picker-options="pickerOptions"
                      start-placeholder="Start Date"
                      end-placeholder="End Date"
                      align="right"
                      style="width: 100%"
                      @change="changeCampaignPeriod(scope.row)"
                      format="DD/MM/YYYY"
                      value-format="YYYY-MM-DD"
                      class="date"
                      :class="{
                        'has-error': validation.isError(
                          scope.row.validate,
                          'dates'
                        ),
                      }"
                      :disabledDate="pickerOptions"
                    >
                    </el-date-picker>
                  </base-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="noOfDays" label="Days" min-width="70">
            </el-table-column>
            <el-table-column
              prop="grossItemSum"
              label="Gross Item Sum"
              min-width="150"
              :formatter="formatterCellMoney"
            >
            </el-table-column>
            <el-table-column label="Visual Date">
              <template #default>
                <div>
                  <el-button
                    link
                    :underline="true"
                    type="primary"
                    @click="visualSettingShow(index)"
                    :disabled="useContract.ContractType == 'media'"
                  >
                    <div style="text-decoration-line: underline">Setting</div>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- Media Select -->
    <el-dialog
      title="Media Select"
      v-model="mediaSelectDialogShow"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      @closed="CloseMedia"
      width="60%"
    >
      <div style="margin-right: 30px">
        <div v-if="mediaSelectDialogIndex === -1">
          <div style="display: flex">
            <h4 style="margin-right: 25px; line-height: 32px">Tier</h4>
          </div>
          <div style="display: flex">
            <div class="groupButtonBus">Bus</div>
            <div class="groupButtonOutdoor">Outdoor</div>
            <div class="groupButtonMtr">MTR</div>
          </div>
        </div>

        <div v-if="mediaSelectDialogIndex === -1">
          <div style="display: flex">
            <h4 style="margin-right: 25px; line-height: 32px">City</h4>
          </div>
          <base-input>
            <el-select
              v-model="selectedCity"
              placeholder="City"
              class="select-primary"
              size="large"
              filterable
              multiple
              @change="changeMediaOption"
            >
              <el-option
                v-for="option in CityOptions"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>

        <div v-if="mediaSelectDialogIndex === -1">
          <div style="display: flex">
            <h4 style="margin-right: 25px; line-height: 32px">Location</h4>
          </div>
          <base-input>
            <el-select
              v-model="selectedLocation"
              placeholder="Location"
              class="select-primary"
              size="large"
              filterable
              multiple
              @change="changeMediaOption"
            >
              <el-option
                v-for="option in LocationOptions"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>

        <div v-if="mediaSelectDialogIndex === -1">
          <div style="display: flex">
            <h4 style="margin-right: 25px; line-height: 32px">Format</h4>
          </div>
          <base-input>
            <el-select
              v-model="selectedFormat"
              placeholder="Format"
              class="select-primary"
              size="large"
              filterable
              multiple
              @change="changeMediaOption"
            >
              <el-option
                v-for="option in FormatOptions"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>

        <div v-if="mediaSelectDialogIndex === -1">
          <div style="display: flex">
            <h4 style="margin-right: 25px; line-height: 32px">Media</h4>
          </div>
          <div style="position: relative">
            <base-input style="width: 100%">
              <el-select
                v-model="selectedMedia"
                placeholder="Media"
                class="select-primary"
                size="large"
                filterable
                multiple
              >
                <el-option
                  v-for="moption in MediaOptions"
                  class="select-primary"
                  :value="moption.value"
                  :label="moption.label"
                  :key="moption"
                >
                </el-option>
              </el-select>
            </base-input>
            <div
              style="
                line-height: 36px;
                position: absolute;
                right: -39px;
                top: 0;
              "
            >
              <span class="add-button">
                <base-button
                  @click="AddMediaSelects"
                  link
                  class="base-icon-button"
                >
                  <div class="icon-button add">
                    <el-icon color="#fff" style="vertical-align: middle">
                      <plus />
                    </el-icon>
                  </div>
                </base-button>
              </span>
            </div>
          </div>
        </div>

        <div style="display: flex">
          <h4 style="margin-right: 25px; line-height: 32px">Selected Media</h4>
        </div>

        <!-- <el-scrollbar max-height="280px"> -->
        <div>
          <div
            class="newCardNoPadding"
            v-for="(mediaitem, index) in selectedMediaInfos"
            :key="mediaitem"
          >
            <div
              style="
                border-bottom: 1px solid #e3e3e3;
                padding: 11px 11px 5px 11px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div>{{ mediaitem.mediaCode }} - {{ mediaitem.mediaName }}</div>
              <div class="add-button">
                <base-button
                  class="base-icon-button"
                  link
                  @click="SubstractMedia(index)"
                  :disabled="mediaSelectDialogIndex > -1"
                >
                  <div class="icon-button substract">
                    <el-icon color="#fff" style="vertical-align: middle">
                      <minus />
                    </el-icon>
                  </div>
                </base-button>
              </div>
            </div>

            <div style="padding-top: 11px">
              <!-- <div class="row" style="margin-left: 0px; margin-right: 0px">
                <div
                  class="col-md-12 description-line"
                  style="padding: 0; line-height: 32px"
                >
                  <div
                    class="row description col-sm-12"
                    style="
                      color: #423022;
                      padding-left: 0px;
                      padding-right: 15px;
                      margin-left: -4px;
                      margin-right: 0px;
                    "
                  >
                    <div class="col-sm-2">
                      <span>Format: </span><label>{{ mediaitem.format }}</label>
                    </div>
                    <div class="col-sm-2">
                      <span>Subgroup Code: </span
                      ><label>{{ mediaitem.subgroupCode }}</label>
                    </div>
                    <div class="col-sm-3">
                      <span>Site Code: </span
                      ><label>{{ mediaitem.siteCode }}</label>
                    </div>
                    <div class="col-sm-3" style="color: #4ab45f">
                      <div>
                        <base-input>
                          <el-select
                            class="select-primary"
                            v-model="mediaitem.planId"
                            style="width: 98%"
                          >
                            <el-option
                              class="select-primary"
                              v-for="item in mediaitem.plans"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              @click="selectPlans(mediaitem, item)"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                    <div class="col-sm-2" style="padding-right: 0">
                      <div style="display: flex; justify-content: end">
                        <div>Qty:</div>
                        <div
                          style="
                            text-align: right;
                            width: 70px;
                            height: 32px;
                            margin: 0px 0px 0 9px;
                            border-radius: 6px;
                            background-color: #fff;
                          "
                        >
                          <base-input
                            v-model="mediaitem.quantity"
                            @blur="NumberError(mediaitem.quantity)"
                            :class="{
                              'has-error': NumberError0(mediaitem.quantity),
                            }"
                          ></base-input>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-2">
                      <span>Location: </span
                      ><label>{{ mediaitem.location }}</label>
                    </div>
                    <div class="col-sm-10">
                      <span
                        style="
                          color: var(--primary);
                          width: 40px;
                          height: 26px;
                          padding: 5px 9px 4px 9px;
                          border-radius: 26px;
                          background-color: #ebf8ff;
                        "
                        v-if="mediaitem.is360"
                        >360</span
                      >
                    </div>
                    <div class="col-sm-12">
                      <span>Remark: </span><label>{{ mediaitem.remark }}</label>
                    </div>
                  </div>
                </div>
              </div> -->
              <el-row>
                <el-col :span="24" class="description-line">
                  <el-row
                    :span="24"
                    :gutter="5"
                    class="row description"
                    style="
                      color: #423022;
                      padding-left: 15px;
                      padding-right: 15px;
                      margin-left: 4px;
                      margin-right: 4px;
                    "
                  >
                    <el-col :span="6">
                      <span>Format: </span><label>{{ mediaitem.format }}</label>
                    </el-col>
                    <el-col :span="5">
                      <span>Subgroup Code: </span
                      ><label>{{ mediaitem.subgroupCode }}</label>
                    </el-col>
                    <el-col :span="4">
                      <span>Site Code: </span
                      ><label>{{ mediaitem.siteCode }}</label>
                    </el-col>
                    <el-col :span="6" style="color: #4ab45f">
                      <div>
                        <base-input>
                          <el-select
                            class="select-primary"
                            v-model="mediaitem.planId"
                            style="width: 98%"
                          >
                            <el-option
                              class="select-primary"
                              v-for="item in mediaitem.plans"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                              @click="selectPlans(mediaitem, item)"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </el-col>
                    <el-col :span="3" style="padding-right: 0">
                      <div style="display: flex; justify-content: end">
                        <div style="width: 41px; min-width: 41px">Qty:</div>
                        <div
                          style="
                            text-align: right;
                            height: 32px;
                            margin: 0;
                            border-radius: 6px;
                            background-color: #fff;
                            flex-grow: 1;
                          "
                        >
                          <base-input
                            v-model="mediaitem.quantity"
                            @blur="NumberError(mediaitem.quantity)"
                            :class="{
                              'has-error': NumberError0(mediaitem.quantity),
                            }"
                          ></base-input>
                        </div>
                      </div>
                    </el-col>

                    <el-col :span="6">
                      <span>Location: </span
                      ><label>{{ mediaitem.location }}</label>
                    </el-col>
                    <el-col :span="18">
                      <span
                        style="
                          color: var(--primary);
                          width: 40px;
                          height: 26px;
                          padding: 5px 9px 4px 9px;
                          border-radius: 26px;
                          background-color: #ebf8ff;
                        "
                        v-if="mediaitem.is360"
                        >360</span
                      >
                    </el-col>
                    <el-col :span="24">
                      <span>Remark: </span><label>{{ mediaitem.remark }}</label>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div v-if="mediaSelectDialogIndex === -1">
          <div style="display: flex">
            <h4 style="margin-right: 25px; line-height: 32px">Campaign Date</h4>
          </div>
          <div style="display: flex">
            <div style="col-sm-10">
              <el-date-picker
                style="width: 530px"
                v-model="MediaCampaignPeriod"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date"
                format="DD/MM/YYYY"
                value-format="YYYY-MM-DD"
                align="right"
                :class="{
                  'form-control': true,
                  'has-error': validation.isError(
                    medaiSelectValidate,
                    'mediaCampaignPeriod'
                  ),
                }"
                :disabledDate="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <div style="margin-right: 30px">
          <base-button type="primary" @click="OkMedias">OK</base-button>
          <base-button @click="mediaSelectDialogShow = false"
            >Close</base-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- Append -->
    <el-dialog
      title="Append"
      v-model="mediaAppendDialogShow"
      :draggable="true"
      :closeOnPressEscape="false"
      :closeOnClickModal="false"
    >
      <div style="margin-right: 30px">
        <div>
          <h4 style="margin-right: 25px; line-height: 32px; margin-left: 5px">
            Descirption
          </h4>
        </div>
        <div style="position: relative; margin-left: 5px">
          <base-input style="width: 100%">
            <el-input
              type="textarea"
              :rows="6"
              v-model="dialogAppend"
            ></el-input>
          </base-input>
        </div>
        <div><el-divider /></div>
        <div>
          <h4 style="line-height: 32px">Bus Shelter</h4>
        </div>
        <div>
          <h4 style="margin-right: 25px; margin-left: 5px; line-height: 32px">
            District
          </h4>
        </div>
        <div style="position: relative; margin-left: 5px">
          <base-input style="width: 100%">
            <el-select
              v-model="DistrictList"
              placeholder="District"
              class="select-primary"
              size="large"
              filterable
              multiple
              @change="changeDistrictList"
            >
              <el-option
                class="select-primary"
                v-for="adoptional in DistrictOptions"
                :key="adoptional.value"
                :value="adoptional.value"
                :label="adoptional.label"
              ></el-option>
              <!-- <el-option value="xx">xx</el-option>
              <el-option value="xxxxx">xxxxx</el-option> -->
            </el-select>
          </base-input>
        </div>
        <div>
          <h4 style="margin-right: 25px; line-height: 32px; margin-left: 5px">
            District/Shelter No./Address
          </h4>
        </div>
        <div style="position: relative; margin-left: 5px">
          <base-input style="width: 100%">
            <el-select
              v-model="ShelterNoAddressList"
              placeholder="District/Shelter No./Address"
              class="select-primary"
              size="large"
              filterable
              multiple
            >
              <el-option
                class="select-primary"
                v-for="adoptional in ShelterNoAddressOptions"
                :key="adoptional.value"
                :value="adoptional.value"
                :label="adoptional.label"
              ></el-option>
            </el-select>
          </base-input>
          <div
            style="line-height: 36px; position: absolute; right: -39px; top: 0"
            v-if="mediaSelectDialogIndex === -1"
          >
            <span class="add-button">
              <base-button link @click="AddAppend" class="base-icon-button">
                <div class="icon-button add">
                  <el-icon color="#fff" style="vertical-align: middle">
                    <plus />
                  </el-icon>
                </div>
              </base-button>
            </span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="margin-right: 30px; text-align: right">
          <base-button type="primary" @click="OkAppend">OK</base-button>
          <base-button @click="CloseAppend">Cancel</base-button>
        </div>
      </div>
    </el-dialog>
    <!-- Visual Date Setting -->
    <el-dialog
      title="Visual Date Setting"
      v-model="visualDateDialogShow"
      width="500"
      style="height: var(--visual-dialog-height)"
    >
      <visualDateSetting
        :media_name="VisualSettingInfo.media_name"
        :visual_date="VisualSettingInfo.visual_date"
        :is-update="VisualSettingInfo.isUpdate"
        :is-init="visualDateDialogShow"
        :campaign-period="VisualSettingInfo.campaign_period"
        :default-value="VisualSettingInfo.campaign_period?.[0]"
        :operation="{
          edit: {
            enable: useContract
              .getContractFunctionPermission('VisualSetting')
              ?.actions?.includes('edit'),
            disabled: !useContract
              .getContractFunctionPermission('VisualSetting')
              ?.actions?.includes('edit'),
          },
          delete: {
            enable: useContract
              .getContractFunctionPermission('VisualSetting')
              ?.actions?.includes('delete'),
            disabled: !useContract
              .getContractFunctionPermission('VisualSetting')
              ?.actions?.includes('edit'),
          },
          add: {
            enable: useContract
              .getContractFunctionPermission('VisualSetting')
              ?.actions?.includes('new'),
            disabled: !useContract
              .getContractFunctionPermission('VisualSetting')
              ?.actions?.includes('new'),
          },
        }"
        @update="UpdateVisualDate"
      />
      <div slot="footer" class="dialog-footer">
        <div style="text-align: right">
          <base-button
            type="primary"
            @click="OKVisualDate"
            v-if="
              !useContract.getContractFunctionPermission('VisualSetting')
                ?.disable
            "
            >Confirm</base-button
          >

          <base-button
            @click="CloseVisualDate"
            v-if="
              !useContract.getContractFunctionPermission('VisualSetting')
                ?.disable
            "
            >Cancel</base-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- tooltip -->
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import baseCheckbox from '@/components/newUI/Inputs/BaseCheckbox';
import append from './append.vue';
import visualDateSetting from './visualDateSetting.vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { CaretBottom, Plus, Minus } from '@element-plus/icons-vue';
import { nextTick, ref, reactive } from 'vue';
import { storeToRefs } from 'pinia';
import { v4 } from 'uuid';

import {
  formatterCellMoney,
  formatterPeriodDate,
  formatterRate,
} from '@/assets/js/formatter';
import validation from '@/assets/js/validation.js';
import dateJs from '@/assets/js/date.js';

import { useContractStore } from '@/store/contract';
import { useMediaItemsStore } from '@/store/mediaItem';
import { useInternalSplitStore } from '@/store/internalsplit';
import contractnet from '@/network/contractnet';

import { Warning } from '@element-plus/icons-vue';

const props = defineProps({
  disabled: Boolean,
  BusinessUnit: {
    type: Object,
    description: 'BusinessUnit',
  },
});

const messageConfig = require('@/models/messageConfig.js');
const mediaJs = require('../js/Media.js');

const useContract = useContractStore();

const { Id } = storeToRefs(useContract);

const useMediaItems = useMediaItemsStore();

const {
  OrderMediaItems,
  MediaList,
  MediaSettings,
  CityOptions,
  LocationOptions,
  FormatOptions,
  MediaOptions,
  DistrictOptions,
  ShelterNoAddressOptions,
} = storeToRefs(useMediaItems);

var mediaSelectDialogShow = ref(false);
var visualDateDialogShow = ref(false);
var mediaSelectDialogIndex = ref(-1);
var medaiSelectValidate = ref([]);
var selectedCity = ref([]);
var selectedLocation = ref([]);
var selectedFormat = ref([]);
var selectedMedia = ref([]);
var selectedMediaInfos = ref([]);
const MediaCampaignPeriod = ref([]);
var mediaAppendDialogShow = ref(false);
var mediaAppendDialogIndex = ref(-1);
var dialogAppend = ref('');
const DistrictList = ref([]);
const ShelterNoAddressList = ref([]);

const showMediaSelectDialog = () => {
  mediaSelectDialogShow.value = true;

  selectedCity.value = [];
  selectedLocation.value = [];
  selectedFormat.value = [];
  selectedMediaInfos.value = [];
  selectedMedia.value = [];

  changeMediaOption();
};
const showMediaAppendDialog = async (index) => {
  mediaAppendDialogShow.value = true;

  mediaAppendDialogIndex.value = index;
  dialogAppend.value = OrderMediaItems.value[index].append;
  DistrictList.value = [];
  ShelterNoAddressList.value = [];
  useMediaItems.ShelterNoAddressOptions =
    useMediaItems.ShelterNoAddressOptionsOld;

  await nextTick();
};

const VisualSettingInfo = reactive({});

// Formatter => Campaign Period
const CampaignPeriodFormatter = (row, column, cellValue) => {
  return formatterPeriodDate(row, column, cellValue);
};
// 复制媒体
const CopyMedia = (index) => {
  var MediaObj;

  if (useContract.getContractType() === 'media') {
    MediaObj = { ...OrderMediaItems.value[index] };
  } else if (useContract.getContractType() === 'production') {
    MediaObj = { ...OrderMediaItems.value[index] };
    MediaObj.visualDate = JSON.stringify([
      { contract: MediaObj.startDate, actual: MediaObj.startDate },
    ]);
  }

  MediaObj.id = 0;
  MediaObj.contractMedia_Id = v4();

  OrderMediaItems.value.push(MediaObj);
};
// 修改媒体
const EditMedia = (index) => {
  mediaSelectDialogShow.value = true;
  mediaSelectDialogIndex.value = index;

  var MediaObj = JSON.parse(JSON.stringify(OrderMediaItems.value[index]));

  var _mediaInfo = MediaList.value.find((t) => t.mediaId === MediaObj.mediaId);

  // Plans
  MediaObj.plans = _mediaInfo?.plans || [];
  MediaObj.is360 = _mediaInfo?.is360 || false;
  selectedMediaInfos.value = [MediaObj];

  MediaCampaignPeriod.value = [MediaObj.startDate, MediaObj.endDate];
};
// Action => Delete
const DeleteMedia = (index) => {
  ElMessageBox.confirm('Do you want Delete Media?', 'Delete Media', {
    distinguishCancelAndClose: true,
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    customClass: 'matrix-message-box',
    confirmButtonClass: 'right-confirm-1',
    closeOnPressEscape: false,
    closeOnClickModal: false,
  }).then(async () => {
    OrderMediaItems.value.splice(index, 1);

    var deleteMediaAlert = useContract.getDeleteMediaAlert();

    if (deleteMediaAlert) {
      ElMessage({
        message: deleteMediaAlert,
        type: 'warning',
      });
    }
  });
};
import { debounce } from 'lodash';
// Media Select => Ok Button
const OkMedias = debounce(async () => {
  //quantity是否有不是数字的参数
  const errorCount = selectedMediaInfos.value.filter((value) =>
    NumberError0(value.quantity)
  );

  if (errorCount.length > 0) {
    ElMessage({
      message: messageConfig.getMessage('errornumber'),
      type: 'warning',
    });
    return;
  }
  const mediaSelectRules =
    require('../js/contractMediaRules.js').mediaSelectRules;

  const source = {
    selectedMediaInfo: selectedMediaInfos.value,
    mediaCampaignPeriod: MediaCampaignPeriod.value,
  };
  // 基础检查
  const errors = await validation
    .validate(source, mediaSelectRules)
    .then((err) => err);
  if (errors.length > 0) {
    ElMessage({
      message: errors[0].message,
      type: 'warning',
    });

    medaiSelectValidate.value = errors;

    return;
  }

  var bValidate = MediaPlatformValidator();
  if (!bValidate) {
    ElMessage({
      message: messageConfig.getMessage('diffplatform'),
      type: 'warning',
    });
    return;
  }

  const media_rules = {
    subgroupCodes: {
      required: true,
      type: 'array',
      message: 'Unable to mix different Subgroup Code media in this contract',
      validator(rule, value) {
        return Array.from(new Set(value || [])).length <= 1;
      },
    },
    unitRate_types: {
      type: 'array',
      message: 'Unable to mix different Price Option media in this contract.',
      validator(rule, value) {
        return Array.from(new Set(value || [])).length <= 1;
      },
    },
  };

  const media_source = {
    subgroupCodes: selectedMediaInfos.value.map((t) => t.subgroupCode),
    unitRate_types: selectedMediaInfos.value.map(
      (t) => t?.media_plan?.unitRate?.type || ''
    ),
  };

  if (OrderMediaItems.value.length > 0) {
    media_source.subgroupCodes = media_source.subgroupCodes.concat(
      OrderMediaItems.value.map((t) => t.subgroupCode)
    );
    media_source.unitRate_types = media_source.unitRate_types.concat(
      OrderMediaItems.value.map((t) => t?.media_plan?.unitRate?.type || '')
    );
  }

  const media_rules_validator = await validation
    .validate(media_source, media_rules)
    .then((err) => err);

  if (media_rules_validator?.length > 0) {
    ElMessage({
      message: media_rules_validator[0].message,
      type: 'warning',
    });
    return;
  }

  // bValidate = MediaSubgroupCodeValidator();
  // if (!bValidate) {
  //   ElMessage({
  //     message: messageConfig.getMessage('diffsubgroup'),
  //     type: 'warning',
  //   });
  //   return;
  // }

  AddContractMedias();

  mediaSelectDialogShow.value = false;
}, 500);

// add append
const AddAppend = async () => {
  var list = dialogAppend.value.split(/[\r\n\t]/);
  var datastr = dialogAppend.value;
  ShelterNoAddressList.value.forEach((value) => {
    var list2 = value.split('/');
    //只添加前两位/
    if (list2.length == 3) {
      value = list2[0] + '/' + list2[1];
    }
    if (list.indexOf(value) < 0) {
      if (datastr.length > 0) {
        datastr = value + '\n' + datastr;
      } else {
        datastr = value;
      }
    }
  });
  ShelterNoAddressList.value = [];

  DistrictList.value = [];
  dialogAppend.value = datastr;
  //恢复数据,去除筛选
  useMediaItems.ShelterNoAddressOptions =
    useMediaItems.ShelterNoAddressOptionsOld;
};
const OkAppend = async () => {
  OrderMediaItems.value[mediaAppendDialogIndex.value].append =
    dialogAppend.value;

  CloseAppend();
};
const CloseAppend = () => {
  mediaAppendDialogIndex.value = -1;
  dialogAppend.value = '';

  mediaAppendDialogShow.value = false;
};
const CloseMedia = () => {
  ResetMediaSelect();
};
const MediaPlatformValidator = () => {
  if (selectedMediaInfos.value.length === 0) {
    return true;
  }

  const MediaSelectMediaTypes = Array.from(
    new Set(
      selectedMediaInfos.value.map(
        (t) =>
          MediaSettings.value.find(
            (a) => a.mediaCategory.indexOf(t.category) >= 0
          )?.mediaType || ''
      )
    )
  );

  // 选择的媒体是否是多个媒体类型
  if (MediaSelectMediaTypes.length > 1 || MediaSelectMediaTypes[0] === '') {
    return false;
  }

  var mediaType = '';

  if (OrderMediaItems.value.length > 0) {
    mediaType =
      MediaSettings.value.find(
        (t) => t.mediaCategory.indexOf(OrderMediaItems.value[0].category) >= 0
      )?.mediaType || '';
  }

  if (
    OrderMediaItems.value.length > 0 &&
    MediaSelectMediaTypes[0] !== mediaType
  ) {
    return false;
  }
  return true;
};
const MediaOperatorValidator = () => {
  if (selectedMediaInfos.value.length === 0) {
    return true;
  }

  var operator = selectedMediaInfos.value[0].operator;

  if (OrderMediaItems.value.length > 0) {
    operator = Array.from(
      new Set(OrderMediaItems.value.map((t) => t.operator))
    )[0];
  }

  const selectedOperators = Array.from(
    new Set(selectedMediaInfos.value.map((t) => t.operator))
  );

  if (selectedOperators.length > 1 || operator !== selectedOperators[0]) {
    return false;
  }
  return true;
};

const MediaSubgroupCodeValidator = () => {
  if (selectedMediaInfos.value.length === 0) {
    return true;
  }

  var subgroupCode = selectedMediaInfos.value[0].subgroupCode;

  if (OrderMediaItems.value.length > 0) {
    subgroupCode = Array.from(
      new Set(OrderMediaItems.value.map((t) => t.subgroupCode))
    )[0];
  }

  const selectedsubgroupCodes = Array.from(
    new Set(selectedMediaInfos.value.map((t) => t.subgroupCode))
  );

  if (
    selectedsubgroupCodes.length > 1 ||
    subgroupCode !== selectedsubgroupCodes[0]
  ) {
    return false;
  }
  return true;
};
const AddContractMedias = () => {
  selectedMediaInfos.value.map((t) => {
    var entity = t;
    entity.dates = [MediaCampaignPeriod.value[0], MediaCampaignPeriod.value[1]];
    entity.unitRateOptionObject = entity.media_plan.unitRate;
    entity.unitRateOption = JSON.stringify(entity.unitRateOptionObject);
    //entity.unitRate = entity.unitRateOption.unitRate;

    if (!entity.visualDate && useContract.getContractType() == 'production') {
      entity.visualDate = JSON.stringify([
        { contract: entity.dates[0], actual: entity.dates[0] },
      ]);
    }

    changeDays(entity);

    if (mediaSelectDialogIndex.value === -1) {
      entity.contractId = Id.value;
      entity.append = '';
      entity.isBonus = false;
      entity.isToBeConfirmed = false;
      entity.contractMedia_Id = v4();
      OrderMediaItems.value.push(entity);
    } else {
      OrderMediaItems.value[mediaSelectDialogIndex.value].planId =
        entity.planId;
      OrderMediaItems.value[mediaSelectDialogIndex.value].media_plan =
        entity.media_plan;
      OrderMediaItems.value[mediaSelectDialogIndex.value].mediaPlan =
        entity.mediaPlan;
      OrderMediaItems.value[mediaSelectDialogIndex.value].quantity =
        entity.quantity;
      OrderMediaItems.value[mediaSelectDialogIndex.value].dates =
        MediaCampaignPeriod.value;
      OrderMediaItems.value[mediaSelectDialogIndex.value].startDate =
        entity.dates[0];
      OrderMediaItems.value[mediaSelectDialogIndex.value].endDate =
        entity.dates[1];
      OrderMediaItems.value[mediaSelectDialogIndex.value].noOfDays =
        entity.noOfDays;
      OrderMediaItems.value[mediaSelectDialogIndex.value].unitRateOption =
        entity.unitRateOption;
      OrderMediaItems.value[mediaSelectDialogIndex.value].unitRateOptionObject =
        entity.unitRateOptionObject;
      // OrderMediaItems.value[mediaSelectDialogIndex.value].unitRate =
      //   entity.unitRate;
      OrderMediaItems.value[mediaSelectDialogIndex.value].grossItemSum =
        entity.grossItemSum;
      OrderMediaItems.value[mediaSelectDialogIndex.value].grossRate =
        entity.grossRate;
      OrderMediaItems.value[mediaSelectDialogIndex.value].unitQty =
        entity.unitQty;
    }
  });
};
// Calculate => NoofDays
const changeDays = (item) => {
  if (item.dates && item.dates.length == 2) {
    item.startDate = item.dates[0];
    item.endDate = item.dates[1];
    item.noOfDays = dateJs.DateDiff(item.startDate, item.endDate) + 1;

    changeGrossItemSum(item);
  }
};
// 更新媒体周期
const changeCampaignPeriod = async (item) => {
  if (item.visualDate?.length > 0) {
    var dayjs = require('dayjs');
    var startSame = dayjs(item.startDate).isSame(item.dates[0]);
    var endSame = dayjs(item.endDate).isSame(item.dates[1]);

    if (!startSame || !endSame) {
      item.visualDate = JSON.stringify([
        { contract: item.dates[0], actual: item.dates[0] },
      ]);
      ElMessage({
        message:
          'Visual date(s) will be reset as the campaign period is changed.',
        type: 'warning',
      });
    }
  }

  changeDays(item);
};
// Calculate => GrossItemSum
const changeGrossItemSum = async (item) => {
  //每天价格*数量*天数

  if (
    item.category == 'Apps' ||
    (item.rateOption.indexOf('IMP') >= 0 && item.planName === 'CPM')
  ) {
    var inventory = 0;
    if (item.media_plan) {
      inventory = item.media_plan.inventoryDeduction;
    }
    item.grossItemSum = (item.grossRate / inventory) * item.quantity;
  } else {
    // 按照plan计划进行计算
    var UnitRate = 0;

    if (item.media_plan?.unitRate?.type === 'Week') {
      UnitRate = 7;
      item.grossItemSum = Math.round(
        (item.grossRate / item.unitQty / UnitRate) *
          item.quantity *
          item.noOfDays,
        0
      ).toFixed(2);
    } else if (item.media_plan?.unitRate?.type == 'Month') {
      var dayjs = require('dayjs');
      var startDay = dayjs(item.dates[0]);
      var endDay = dayjs(item.dates[1]);

      var bMonth =
        new Date(item.dates[0]).getDate() == 1 &&
        new Date(item.dates[1]).getDate() == endDay.daysInMonth(); //足月

      // 足月a计算,不足月b计算
      if (bMonth) {
        var diffMonth = Math.round(endDay.diff(startDay, 'month', true), 0);
        item.grossItemSum = Math.round(
          (item.grossRate / item.unitQty) * diffMonth * item.quantity,
          0
        ).toFixed(2);
      } else {
        item.grossItemSum = Math.round(
          (((item.grossRate / item.unitQty) * 12) / 365) *
            item.noOfDays *
            item.quantity,
          0
        ).toFixed(2);
      }
    } else if (item.media_plan?.unitRate?.type == 'Year') {
      UnitRate = 365;
      item.grossItemSum = Math.round(
        (item.grossRate / UnitRate) * item.quantity * item.noOfDays,
        0
      ).toFixed(2);
    } else {
      item.grossItemSum = Math.round(item.grossRate * item.quantity, 0).toFixed(
        2
      );
    }
  }
};

const calcUnitRate = (data, mia_media_info) => {
  var grossRate = parseFloat(data.grossRate.replace(/,/g, ''));
  // if (useContract.Unit.alias === 'BB' && data.includeCost) {
  //   grossRate = mia_media_info?.newaddedinfo?.nettMediaCost || 0;
  // }

  // if (grossRate == 0) {
  //   grossRate = parseFloat(data.grossRate.replace(/,/g, ''))
  // }

  if (data?.unitRate?.type == 'Week') {
    return Math.round(grossRate / data.unitRate.unitRateQty, 0);
  } else if (data?.unitRate?.type == 'Month') {
    return Math.round(grossRate / data.unitRate.unitRateQty, 0);
  }
  return 0;
};
// 媒体按周按月
// const setUnitRateOption = (data) => {
//   var unitRate = 0;
//   var type = '';
//   if (data.rateOption.indexOf('Week') >= 0) {
//     unitRate = 7;
//     type = 'Week';
//   } else if (data.rateOption.indexOf('Month') >= 0) {
//     unitRate = 30;
//     type = 'Month';
//   }

//   return {
//     unitRate,
//     type,
//   };
// };

const inputBlur = async (index, field) => {
  await useMediaItems.validate(index).then((msg) => msg);
  if (validation.isError(OrderMediaItems.value[index].validate, field)) {
    ElMessage({
      message:
        OrderMediaItems.value[index].validate.find((t) => t.field === field)
          ?.message || '',
      type: 'warning',
    });
  }
};
// 数字类型验证
const NumberError = (value) => {
  if (NumberError0(value)) {
    ElMessage({
      message: messageConfig.getMessage('errornumber'),
      type: 'warning',
    });
  }
};
// 数字类型验证
const NumberError0 = (value) => {
  return !validation.NumberValidate(value) || value == '0' || value == 0;
};

const ResetMediaSelect = () => {
  selectedMediaInfos.value = [];
  selectedCity.value = [];
  selectedFormat.value = [];
  selectedLocation.value = [];
  mediaSelectDialogIndex;
  mediaSelectDialogIndex.value = -1;
  medaiSelectValidate.value = [];
  MediaCampaignPeriod.value = [];
};
// MediaSelect => 添加
const AddMediaSelects = () => {
  selectedMedia.value.map((t) => {
    var item = MediaList.value.find((ml) => ml.mediaId == t) || null;
    if (item != null) {
      //多少周
      // var val = 1;
      // var Rates = item.priceOption.split(" ");
      // if (Rates.length > 0) {
      //   Rates.map((t) => {
      //     if (!isNaN(parseInt(t))) {
      //       val = parseInt(t) || 1;
      //     }
      //   });
      // }

      var mediaPlan = { ...item.plans.find((t) => t.value === item.planId) };

      const mediaObj = {
        id: 0,
        tier: item.tier,
        category: item.category,
        city: item.city,
        mediaId: item.mediaId,
        planId: item.planId,
        planName: item.planName,
        planLabel: item.plans[0].label,
        currency: item.currency,
        planGrossRate: item.grossRate.replaceAll(',', ''),
        mediaCode: item.mediaCode,
        mediaName: item.mediaName,
        format: item.format,
        operator: item.operator,
        location: item.location,
        mediaRemark: item.remark,
        unitQty: item.unitQty,
        day: item.day,
        internalCode: item.internalCode,
        priceOption: item.priceOption,
        // grossRate: item.grossRate.replaceAll(',', '') / val,
        grossRate: calcUnitRate(mediaPlan, item),
        quantity: 1,
        rateOption: item.rateOption,
        subgroupCode: item.subgroupCode,
        unitCN: item.unitCN,
        unitEN: item.unitEN,
        siteCode: item.siteCode,
        is360: item.is360,
        unitProductionCost: 0,
        totalProductionCost: 0,
        contractId: Id.value,
        plans: item.plans,
        mediaPlan: JSON.stringify(mediaPlan),
        media_plan: mediaPlan,
        mediaSnap: JSON.stringify(item),
        isExclusive: item.isExclusive,
      };

      selectedMediaInfos.value.push(mediaObj);
    }
  });

  selectedMedia.value = [];
};
const SubstractMedia = (index) => {
  selectedMediaInfos.value.splice(index, 1);
};
const changeMediaOption = () =>
  useMediaItems.filterMediaOptions(
    selectedCity.value,
    selectedLocation.value,
    selectedFormat.value
  );
//更改District处理
const changeDistrictList = () => {
  var list = useMediaItems.ShelterNoAddressOptionsOld;
  if (DistrictList.value.length < 1) {
    useMediaItems.ShelterNoAddressOptions = list;
    return;
  }
  useMediaItems.ShelterNoAddressOptions = list.filter(
    (t) => DistrictList.value.indexOf(t.district) >= 0
  );
};
//selectPlans
const selectPlans = (data1, data2) => {
  data1.planId = data2.planId;
  data1.currency = data2.currency;
  data1.planName = data2.planName;
  data1.priceOption = data2.planName;
  //data1.grossRate = data2.grossRates;
  data1.grossRate = calcUnitRate(data2, data1);
  data1.rateOption = data2.rateOption;
  data1.planGrossRate = data2.grossRate;
  data1.grossRateDay = data2.grossRateDay;
  data1.grossRates = data2.grossRates;
  data1.day = data2.day;
  data1.unitQty = data2.unitQty;
  data1.media_plan = data2;
  data1.mediaPlan = JSON.stringify(data2);
};
// 禁用日期
//Campaign Date 当天开始
const pickerOptions = (date) => {
  if (props.BusinessUnit?.alias == 'BB') {
    return false;
  }
  const useAuthority = require('@/store/authority').useAuthorityStore();
  if (useAuthority.isOrderTop()) {
    return false;
  }
  return date.getTime() < new Date().getTime() - 86400000;
};
const enableSetting = () => {
  return (
    useContract.getContractType() !== 'production' ||
    useContract.getOrderStatus() === 'Completed'
  );
};

// Visual Setting
const visualSettingShow = (index) => {
  visualDateDialogShow.value = true;

  var Media = OrderMediaItems.value[index];

  VisualSettingInfo.media_name = `${index + 1}.  ${Media.mediaName}`;
  VisualSettingInfo.visual_date = JSON.parse(Media.visualDate || '[]');
  VisualSettingInfo.media_id = Media.contractMedia_Id;
  VisualSettingInfo.id = Media.id;
  VisualSettingInfo.campaign_period = Media.dates;
};

const UpdateVisualDate = async (value) => {
  VisualSettingInfo.isUpdate = false;

  var visual_date = JSON.stringify(value);
  if (!value.isUpdate) {
    return;
  }

  visualDateDialogShow.value = false;

  if (parseFloat(VisualSettingInfo.id) && VisualSettingInfo.id > 0) {
    var res = await contractnet
      .SaveVisualDate(VisualSettingInfo.media_id, visual_date)
      .then((res) => res);

    if (res.data?.message) {
      ElMessage({
        message: res.data.message,
        type: 'error',
      });
      return;
    }

    var ContractSummary = useContract.getContractSummaryData();
    ContractSummary.updateByCode = res.data.updateByCode;
    ContractSummary.updateByName = res.data.updateByName;
    ContractSummary.updateDate = res.data.updateDate;
    useContract.setContractSummaryData(ContractSummary);
  }

  var Media = OrderMediaItems.value.find(
    (t) => t.contractMedia_Id == VisualSettingInfo.media_id
  );

  Media.visualDate = visual_date;
  CloseVisualDate();
};

const OKVisualDate = () => {
  VisualSettingInfo.isUpdate = true;
};

const CloseVisualDate = () => {
  visualDateDialogShow.value = false;
};

const getMediaTechinologyValue = (index) => {
  var technology = JSON.parse(
    OrderMediaItems.value[index].mediaSnap || '{}'
  )?.technology;

  if (technology) {
    var technology_name = JSON.parse(technology)?.[0]?.Name;
    if (technology_name) {
      return JSON.parse(technology_name)?.en;
    }
  }
  return '';
};

const getLocationDescriptionValue = (index) => {
  var locationDescription = JSON.parse(
    OrderMediaItems.value[index].mediaSnap || '{}'
  )?.locationDescription;

  if (locationDescription) {
    return JSON.parse(locationDescription)?.en;
  }
  return '';
};
</script>
<style scoped>
.media-item {
  --visual-dialog-height: calc(85vh - 240px);
}
.base-icon-button {
  margin: 0;
}
.icon-button {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.icon-button.add {
  background-color: #409eff;
  color: #fff;
}

.icon-button.substract {
  background-color: #e56825;
  color: #fff;
}

.base-icon-button.is-disabled .icon-button,
.btn:disabled .icon-button {
  background-color: #979797;
  opacity: 0.5;
}
.btn.append {
  padding-left: 0 !important;
}
</style>
